import React, { useState } from 'react'

const PRIMARY = '#3661EB'
const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

const navItems = [
  { label: 'Dashboard', active: false, icon: '⊞' },
  { label: 'Kehadiran', active: false, icon: '👤' },
  { label: 'Karyawan', active: false, icon: '🧑' },
  { label: 'Jurnal Guru', active: false, icon: '📋' },
  { label: 'Kalender', active: false, icon: '📅' },
  { label: 'Jadwal Guru', active: true, icon: '📆' },
  { label: 'Siswa', active: false, icon: '🎓' },
  { label: 'Logout', active: false, icon: '↩' },
]

function AssignTambahGuruKelas() {
  const [namaGuru, setNamaGuru] = useState('Samuel Umtiti hummington')
  const [kelas, setKelas] = useState('11 PPLG 1')

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#fff', fontFamily: 'Poppins, sans-serif' }}>

      {/* Sidebar */}
      <div style={{
        width: 261, flexShrink: 0, background: '#fff',
        borderRight: `1px solid ${BORDER}`, minHeight: '100vh',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
      }}>
        <div style={{ marginTop: 46, marginBottom: 16, width: 107, height: 108, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{
            width: 90, height: 90, borderRadius: '50%',
            background: 'linear-gradient(135deg, #1a3c7a 0%, #3661EB 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ fontSize: 28 }}>🎓</span>
          </div>
        </div>
        <p style={{ fontSize: 20, fontWeight: 600, color: '#000', margin: '0 0 32px', textAlign: 'center' }}>SMK RUS Kudus</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 32, alignSelf: 'flex-start', paddingLeft: 41, width: '100%' }}>
          {navItems.map((item) => (
            <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
              <span style={{ fontSize: 18, width: 22, textAlign: 'center' }}>{item.icon}</span>
              <span style={{ fontSize: 15, fontWeight: 600, color: item.active ? PRIMARY : GREY }}>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Main */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>

        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 40px', height: 77, borderBottom: `1px solid ${BORDER}`, background: '#fff',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <button onClick={() => window.history.back()} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: '#000' }}>←</button>
            <h2 style={{ fontSize: 24, fontWeight: 500, margin: 0 }}>Tambah Wali Kelas</h2>
          </div>
          <button style={{
            background: PRIMARY, color: '#fff', border: 'none', borderRadius: 8,
            padding: '0 24px', height: 40, fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'Poppins, sans-serif',
          }}>
            Konfirmasi
          </button>
        </div>

        {/* Form */}
        <div style={{ padding: '40px' }}>
          {/* Nama Lengkap */}
          <div style={{ marginBottom: 32 }}>
            <label style={{ display: 'block', fontSize: 18, fontWeight: 500, marginBottom: 12 }}>
              Nama lengkap
            </label>
            <div style={{ position: 'relative', width: 639 }}>
              <select
                value={namaGuru}
                onChange={e => setNamaGuru(e.target.value)}
                style={{
                  width: '100%', height: 48, border: `1px solid ${BORDER}`, borderRadius: 8,
                  padding: '0 40px 0 16px', fontSize: 14, color: '#000', background: '#fff',
                  appearance: 'none', outline: 'none', cursor: 'pointer', fontFamily: 'Poppins, sans-serif',
                }}
              >
                <option value="Samuel Umtiti hummington">Samuel Umtiti hummington</option>
                <option value="Muhammad Firdan Azhari">Muhammad Firdan Azhari</option>
                <option value="Antariksa Kusuma Harmawan">Antariksa Kusuma Harmawan</option>
              </select>
              <span style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#666' }}>▾</span>
            </div>
          </div>

          {/* Kelas */}
          <div style={{ marginBottom: 32 }}>
            <label style={{ display: 'block', fontSize: 18, fontWeight: 500, marginBottom: 12 }}>
              Kelas
            </label>
            <div style={{ position: 'relative', width: 639 }}>
              <select
                value={kelas}
                onChange={e => setKelas(e.target.value)}
                style={{
                  width: '100%', height: 48, border: `1px solid ${BORDER}`, borderRadius: 8,
                  padding: '0 40px 0 16px', fontSize: 14, color: '#000', background: '#fff',
                  appearance: 'none', outline: 'none', cursor: 'pointer', fontFamily: 'Poppins, sans-serif',
                }}
              >
                <option value="11 PPLG 1">11 PPLG 1</option>
                <option value="11 PPLG 2">11 PPLG 2</option>
                <option value="12 PPLG 1">12 PPLG 1</option>
                <option value="12 PPLG 2">12 PPLG 2</option>
              </select>
              <span style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#666' }}>▾</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignTambahGuruKelas
